import { useEffect, useRef, useState } from 'react';
import { hitAudiencies } from 'components/3catinfo/Audiencies/audiencies-datalayer';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Mousewheel } from 'swiper/modules';
import Boto from 'components/3catinfo/Boto';
import Icona from 'components/3catinfo/ui/Icona';
import Destacat from './DestacatBasic';
import clsx from 'clsx';
import styles from './entresminuts.module.scss';

const EnTresMinuts = (props) => {
    const { items = [] } = props;
    const navigationPrev = useRef(null);
    const navigationNext = useRef(null);
    const swiper = useRef(null);
    //const [currentSlide, setCurrentSlide] = useState(1);
    const [isAtLastSlide, setIsAtLastSlide] = useState(false);

    // State per a controlar els slides
    const [slides, setSlides] = useState(items);

    const stylesEnTresMinuts = clsx(styles.contentModalReels, isAtLastSlide && styles.finalSlide);

    // Funció per controlar l'amplada de la finestra
    const updateSlides = () => {
        const screenWidth = window.innerWidth;
        if (screenWidth < 920) {
            // Afegir un slide inicial quan la finestra és petita
            if (!slides[0]?.isInitialSlide) {
                setSlides([{ id: 'initial-slide', isInitialSlide: true }, ...items]);
            }
        } else if (slides[0]?.isInitialSlide) {
            setSlides(items);
        }
    };

    // Actualitzar els slides quan la finestra canvia de mida
    useEffect(() => {
        updateSlides();
        window.addEventListener('resize', updateSlides);
        return () => {
            window.removeEventListener('resize', updateSlides);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [items, slides]);

    const [navigationReady, setNavigationReady] = useState(false);

    useEffect(() => {
        setNavigationReady(true);
    }, []);

    useEffect(() => {
        swiper.current.swiper.navigation.update();
    }, [navigationReady]);

    return (
        <>
            {items && (
                <>
                    <div className={stylesEnTresMinuts}>
                        <div className={styles.aldia}>
                            <h1>
                                <span className='sr-only'>En 3 minuts</span>
                                <Icona
                                    icona='en3minuts'
                                    inline={true}
                                    className={styles.iconaBackground}
                                    alt="Posa't al dia en 3 minuts"
                                />
                            </h1>
                        </div>

                        <div className={styles.itemsWrapper}>
                            <Swiper
                                direction='vertical'
                                ref={swiper}
                                className={styles.swiper}
                                navigation={{
                                    prevEl: navigationPrev.current,
                                    nextEl: navigationNext.current
                                }}
                                // onBeforeInit={(swiper) => {
                                //     swiper.params.navigation.prevEl = navigationPrev.current;
                                //     swiper.params.navigation.nextEl = navigationNext.current;
                                // }}
                                modules={[Navigation, Mousewheel]}
                                mousewheel={{
                                    releaseOnEdges: true,
                                    eventsTarget: 'div.scrollArea',
                                    thresholdTime: 600, //fix touchpads portàtils Windows
                                    thresholdDelta: 20 //fix touchpads portàtils Windows
                                }}
                                onSlideChange={(swiper) => {
                                    window.scrollTo({ top: 0, behavior: 'smooth' });
                                    swiper.params.mousewheel.releaseOnEdges = false;
                                    //setCurrentSlide(swiper.activeIndex + 1);
                                    hitAudiencies('scClicBoto', {
                                        URL: window.location.href,
                                        identificadorClic:
                                            swiper.activeIndex === slides.length
                                                ? `Final`
                                                : `${swiper.activeIndex + 1}:${slides[swiper.activeIndex]?.titol?.replace(
                                                      ':',
                                                      '.'
                                                  )}`
                                    });
                                }}
                                onProgress={(swiper) => {
                                    if (swiper.progress === 1) {
                                        setIsAtLastSlide(true);
                                    } else {
                                        setIsAtLastSlide(false);
                                    }
                                }}
                                onReachEnd={(swiper) => {
                                    setTimeout(function () {
                                        swiper.params.mousewheel.releaseOnEdges = true;
                                    }, 500);
                                }}
                                onReachBeginning={(swiper) => {
                                    setTimeout(function () {
                                        swiper.params.mousewheel.releaseOnEdges = true;
                                    }, 500);
                                }}
                                slidesPerView={'auto'}
                                slidesPerGroup={1}
                                spaceBetween={32}
                                touchReleaseOnEdges={true}
                                longSwipes={false}
                            >
                                {slides.map((item, i) =>
                                    item.isInitialSlide ? (
                                        <SwiperSlide key='initial-slide'>
                                            <div className={styles.aldia}>
                                                <Icona
                                                    icona='en3minuts'
                                                    inline={true}
                                                    className={styles.iconaBackground}
                                                    alt="Posa't al dia en 3 minuts"
                                                />
                                            </div>
                                        </SwiperSlide>
                                    ) : (
                                        <SwiperSlide key={`item-cinc-minuts-${item.id}-${i}`}>
                                            <Destacat item={item} tipologia='not_noticia' />
                                        </SwiperSlide>
                                    )
                                )}

                                <SwiperSlide>
                                    <div className={styles.fi}>
                                        <Icona icona='checked_contorn_cercle' inline={true} className={styles.iconaCheck} />
                                        <span className={styles.bigText}>Ja t&apos;has posat al dia!</span>
                                        <span>Si vols seguir informant-te...</span>
                                        <Boto
                                            text='Ves a la portada'
                                            mida='s'
                                            link='/3catinfo'
                                            dataTestId={`boto-tots`}
                                            className={styles.botoPortada}
                                        />
                                    </div>
                                </SwiperSlide>
                            </Swiper>
                        </div>

                        <div className={styles.fletxes}>
                            <button ref={navigationPrev} className={styles.fletxaNav}>
                                <Icona icona='fletxa_amunt' alt='Anterior' inline={true} mida={24} className={styles.iconaNav} />
                            </button>
                            <button ref={navigationNext} className={styles.fletxaNav}>
                                <Icona icona='fletxa_avall' alt='Següent' inline={true} mida={24} className={styles.iconaNav} />
                            </button>
                            {/* <div className={styles.index}>
                                {currentSlide} / {slides.length + 1}
                            </div> */}
                        </div>
                    </div>
                    {/* <div className={styles.fi}>
                        <Icona icona='checked_contorn_cercle' inline={true} className={styles.iconaCheck} />
                        <span className={styles.bigText}>Ja t&apos;has posat al dia!</span>
                        <span>Si vols seguir informant-te...</span>
                        <Boto
                            text='Ves a la portada'
                            mida='s'
                            link='/3catinfo'
                            dataTestId={`boto-tots`}
                            className={styles.botoPortada}
                        />
                    </div> */}
                </>
            )}
        </>
    );
};

export default EnTresMinuts;
